import { Base } from '../base-component';
import './article-filter.component.scss';

export class ArticleFilter extends Base {

	constructor(element: Element){

		super(element);

	}

	// components
	form: any;
	selectButtons: any;
	selectItems: any;
	clearButton: any;

	init(){

		this.form = this.element.querySelector('#article-form-filter');
		this.selectButtons = Array.from(this.element.querySelectorAll('.article-filter__form-field--select-button'));
		this.selectItems = Array.from(this.element.querySelectorAll('.article-filter__form-field--select-box-item'));
		this.clearButton = this.element.querySelector('.js-clear-filters');

	}

	bindEvents() {

		if(this.selectButtons){
			this.selectButtons.map((item) => item.addEventListener('click', (event) => {
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				this.closeAllSelects();
				let parent = element.closest('.article-filter__form-field--container');
				let box = parent.querySelector('.article-filter__form-field--select-box');
				box.classList.toggle('article-filter__form-field--select-box-active');
	
			}));
		}

		if(this.selectItems) {
			this.selectItems.map((item) => item.addEventListener('click', (event) => {
				let element;
				if(event.currentTarget){
					element = event.currentTarget;
				}else{
					element = event.target;
				}
				let value = element.getAttribute('data-value');
				let name = element.getAttribute('data-name');
				let parent = element.closest('.article-filter__form-field--container');
				let button = parent.querySelector('.article-filter__form-field--select-button');
				let box = parent.querySelector('.article-filter__form-field--select-box');
	
				button.innerHTML = name;
				box.classList.toggle('article-filter__form-field--select-box-active');
	
			}));
		}

		if(this.clearButton) {
			this.clearButton.addEventListener('click', (event)=>{
	
				this.form.reset();
	
			});
		}

	}

	closeAllSelects() {

		this.selectButtons.map((item) => {
			let element = item;
			let parent = element.closest('.article-filter__form-field--container');
			let box = parent.querySelector('.article-filter__form-field--select-box');
			box.classList.remove('article-filter__form-field--select-box-active');

		});

	}

}


// WEBPACK FOOTER //
// ./components/article-filter/article-filter.component.ts